/*global ZiggeoApi */
import React from 'react';

let ziggeoInstance;

export function withZiggeo(Component) {
  return class InitializeZiggeo extends React.Component {
    constructor(props) {
      super(props);
      if (!ziggeoInstance && !props.hasZiggeoForAllMedia) {
        ziggeoInstance = new ZiggeoApi.V2.Application({
          token: this.props.apiKey,
          auth: true,
          debug: true,
        });
      }
    }

    render() {
      return React.createElement(Component, this.props);
    }
  };
}

export function getThumbnail(token) {
  if (ziggeoInstance) {
    return ziggeoInstance && ziggeoInstance.videos.imageUrl(token);
  }
  return '';
}

export function createPlayerElement(givenAnswer, questionId, playerElement) {
  const player = new ZiggeoApi.V2.Player({
    element: playerElement || document.getElementById(questionId),
    attrs: {
      width: '100%',
      height: 'auto',
      video: givenAnswer,
      theme: 'modern',
      themecolor: 'black',
    },
  });

  player.activate();
}

export const fileTypes = [
  'mp4',
  'mpg',
  'avi',
  'mov',
  'mkv',
  'wmv',
  'ogv',
  'webm',
  'flv',
];

export function createRecordingElement({
  token,
  saveVideo,
  questionId,
  webcamPlaybackEnabled,
  recordWebcamEvent,
  recordingElement,
  setUploadingComplete,
  setUploadStarted,
  handleBadUploadType,
  hideRecorder,
  allowRecord = true,
}) {
  const recorder = new ZiggeoApi.V2.Recorder({
    element: recordingElement || document.getElementById(questionId),
    attrs: {
      allowrecord: allowRecord,
      width: '100%',
      height: 'auto',
      rerecordable: false,
      video: token,
      recordingwidth: 1280,
      recordingheight: 720,
      picksnapshots: false,
      localplayback: webcamPlaybackEnabled,
      theme: 'modern',
      themecolor: 'black',
    },
  });

  recorder.activate();
  recorder.on('uploading', () => {
    if (setUploadStarted) setUploadStarted();
    if (typeof hideRecorder === 'function') hideRecorder();
    recordWebcamEvent('video_response/webcam_uploading');
  });
  recorder.on('recording', () => {
    recordWebcamEvent('video_response/webcam_recording');
  });
  recorder.on('verified', () => {
    if (setUploadingComplete) setUploadingComplete();
    recordWebcamEvent('video_response/webcam_verified');
    saveVideo();
  });
  recorder.on('upload_selected', file => {
    if (file && handleBadUploadType) {
      const type = file.value.split('.').pop();
      if (!fileTypes.includes(type)) handleBadUploadType();
    }
  });
}

export const mediaLocales = [
  {
    register: {
      'ba-videorecorder-chooser.multi-stream': t(
        'lessons.editor.media_recording.record',
      ),
      'ba-videorecorder-chooser.record-video': t(
        'lessons.editor.media_recording.record',
      ),
      'ba-videorecorder-chooser.record-screen': t(
        'lessons.editor.media_recording.record',
      ),
    },
    priority: 10,
  },
];
